/// \file fleetFaults.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const FleetfaultsList = lazy(() => import('../views/fleet-faults/list/view'));

async function fleetfaultsDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/fleet-faults/list/loader')).default;
  return actualLoader(args);
}

export async function fleetfaultsAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/fleet-faults/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="faults"
    handle={{
      text:"FAULTS"
    }}
  >
    <Route
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <FleetfaultsList />
        </Suspense>
      }
      loader={fleetfaultsDataLoader}
      action={fleetfaultsAction}
      />
  </Route>
);

export default routes;